/**
 * The two things a player can start or join, and the words used for them.
 *
 * One file because the same pair of descriptions appears in three places - the create
 * choice, the join choice and the first-run empty state - and three copies of a
 * sentence drift the moment one of them is edited.
 *
 * The descriptions are deliberately parallel: same length, same rhythm, differing on
 * the one axis that decides between them - does it end, and does anything add up.
 * Two well-written sentences of different shapes read as two unrelated things.
 *
 * `standalone` is the code's word for it, matching the API and the Game model.
 * `One-off game` is the player's word for it. The split is on purpose - keep it.
 */
export const GAME_KINDS = {
  standalone: {
    id: 'standalone',
    label: 'One-off Game',
    blurb: 'One game. Last player standing wins, and that\u2019s that.',
    short: 'One game, one winner.',
    createFlow: 'create-game',
  },
  league: {
    id: 'league',
    label: 'Mini League',
    blurb: 'Game after game, with a league table that carries over.',
    short: 'Games all season, one table.',
    createFlow: 'create-league',
  },
};

export const KIND_LIST = [GAME_KINDS.standalone, GAME_KINDS.league];
